export default __webpack_public_path__ + "static/media/it-gif4.29954f0a.gif";